import {createSelector} from 'reselect';

export const generateBooleanSelector = inputSelector => createSelector(
  inputSelector,
  inputSelectorResult => !!inputSelectorResult,
);
